import React, {
    useState,
    useEffect, 
    // useCallback, 
} from 'react'
import PropTypes from 'prop-types'

import { 
    useForm, 
    // Controller
} from "react-hook-form"
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from "yup";
import classNames from 'classnames';
import axios from 'axios';
import { v4 as uuid } from 'uuid'
import SimpleBar from 'simplebar-react'

// hooks
import useWindowSize from '../../../../Hook/useWindowSize'

// Atoms
import Button from '../../../Atoms/Button'
import SearchField from '../../../Atoms/SearchField'
import Title, { TitleTag, TitleStyle } from '../../../Atoms/Title'
import InputSelect, { InputSelectType } from '../../../Atoms/InputSelect'

// Mol
import PromoCardsMol from '../../../Molecules/Cards/Promo'
import PaginationMol from '../../../Molecules/Pagination'

// Sass
import '../../../../Sass/includes/Components/modules/C12.sass'
import 'simplebar/dist/simplebar.min.css'

const queryParams = new URLSearchParams(window.location.search);

const C12Filtercollapse = (props) =>{

    const {dataFilter, filters, active} = props
    // let init = filters.length > 0 ? !filters.some(f => dataFilter.includes(f.fi_FILTRO)) : true
    const [cond, setCond] = useState(!active)
    if (active !== undefined){

    }
    console.log("C12Filtercollapse", cond, dataFilter, filters, active)
    return (
        <div className={`c12FilterBlock c12FilterBlockCollapse ${cond  ? 'c12FilterBlockHidden':''}`}>
            {props.render(cond, setCond)}
        </div>
    )
}
const C12FiltercollapseHistory = (props) =>{

    const {dataFilter, filters, active} = props
    // let init = filters.length > 0 ? !filters.some(f => dataFilter.includes(f.fi_FILTRO)) : true
    const [cond, setCond] = useState(!active)
    if (active !== undefined){

    }
    console.log("C12Filtercollapse", cond, dataFilter, filters, active)
    return (
        <div className={`c12FilterBlock c12FilterBlockCollapse ${cond  ? 'c12FilterBlockHidden':''}`}>
            {props.render(cond, setCond)}
        </div>
    )
}   

const ElementsFilter = React.memo((props)=>{
    
    const {
        onSubmit,
        showFilter,
        setShowFilter,
        dataCCategorias,
        dataCCategoriasHistory,
        onChange,
        onChangeHistory,
        dataFilter,
        dataFilterHistory,
        cleanFilter,
        onChangeActive,
        onChangeActiveHistory,
    }= props


    const {
        width: widthWindow,
    } = useWindowSize()

    const schemaFilter = yup.object().shape({
    });

    const { 
        handleSubmit,
    } = useForm({
        defaultValues: {
            serMovil: [],
            serHogar: [],
            shop: [],
        },
        resolver: yupResolver(schemaFilter),
    });
    

    const classMain = classNames(
        'c12FilterMain',
        {'c12FilterMainHide' : !showFilter},
    );

    const PlayCategoriasData = dataCCategorias ? dataCCategorias.map((item, index) => (
        <C12Filtercollapse dataFilter={dataFilter} filters={item.filtros} key={uuid()} active={item.active} render={(cond, setCond)=>(
            <>
                <div className='c12FilterSubtitle' onClick={()=>{setCond(c=>!c); onChangeActive(item.active, item.fi_TIPO_FILTRO)}}>
                    <p>
                        {item.fc_DESCRIPCION}
                    </p>
                    <i className={`${cond ? 'ico-chevron-down': 'ico-chevron-up'}`}></i>
                </div>
                <div className={`c12FilterBlockItems c12FilterBlockItemsShow`} >
                    <SimpleBar
                        style={{ maxHeight: "200px" }}
                    >
                        {
                            item?.filtros ? item.filtros.map((itemF, indexF) => (
                                <InputSelect 
                                    key={uuid()}
                                    type={InputSelectType.CHECKBOX} 
                                    //register={register(`serMovil[${indexF}]`, {required: false})}
                                    text={itemF.fc_DESCRIPCION}
                                    name='serMovil'
                                    defaultValue={itemF.fi_FILTRO}
                                    className='c12FilterCheckbox'
                                    onChange={e => { onChange(e,item) }}
                                    checked={dataFilter.includes(itemF.fi_FILTRO)}
                                />
                            )) 
                                : null
                        }
                        
                        
                        
                    </SimpleBar>
                </div>
            </>
        )} />
        )) 
        : null;

        const PlayCategoriasDataHistory = dataCCategoriasHistory ? dataCCategoriasHistory.map((item, index) => (
            <C12FiltercollapseHistory dataFilter={dataFilterHistory} filters={item.filtros} key={uuid()} active={item.active} render={(cond, setCond)=>(
                <>
                    <div className='c12FilterSubtitle' onClick={()=>{setCond(c=>!c);onChangeActiveHistory(item.active, item.fi_TIPO_FILTRO)}}>
                        <p>Histórico {dataCCategoriasHistory?.length > 1 ? item.fc_DESCRIPCION: null}</p>
                        <i className={`${cond ? 'ico-chevron-down': 'ico-chevron-up'}`}></i>
                    </div>
                    <div className={`c12FilterBlockItems c12FilterBlockItemsShow`} >
                        <SimpleBar
                            style={{ maxHeight: "200px" }}
                        >
                            {
                                item?.filtros ? item.filtros.map((itemF, indexF) => (
                                    <InputSelect 
                                        key={uuid()}
                                        type={InputSelectType.CHECKBOX} 
                                        //register={register(`serMovil[${indexF}]`, {required: false})}
                                        text={itemF.fc_DESCRIPCION}
                                        name='serMovil'
                                        defaultValue={itemF.fi_FILTRO}
                                        className='c12FilterCheckbox'
                                        onChange={e => { onChangeHistory(e,item) }}
                                        checked={dataFilterHistory.includes(itemF.fi_FILTRO)}
                                    />
                                )) 
                                    : null
                            }
                            
                            
                            
                        </SimpleBar>
                    </div>
                </>
            )} />
            )) 
            : null;
    

    useEffect(()=>{
        if(widthWindow > 960){
            setShowFilter(true)
           
        }else if(widthWindow <= 960){
            setShowFilter(false)
        }
    },[widthWindow, setShowFilter])
    

    return (
        <div className={classMain}>
            <form 
                className='c12Filter' 
                onSubmit={handleSubmit(onSubmit)}
            >
                {/* Solo se muestra este campo en responsive */}
                <div className='c12FilterBlock c12FilterBlockTop'>
                    {/* <p>
                        Valores de todo el formulario de filtro:
                        { JSON.stringify( getValues())}
                    </p> */}
                    <Title
                        tag={TitleTag.H2}
                        style={TitleStyle.H4}
                        className=''
                    >
                        Filtrar por Categoría
                    </Title>
                    <i className='ico-x' onClick={()=>{setShowFilter(!showFilter)}}></i>
                </div>
                
                {
                    (dataFilter.length || dataFilterHistory.length) > 0 &&
                    <div className='c12FilterClear'>
                        <span>{dataFilter.length + dataFilterHistory.length} filtros seleccionados</span>
                        <span className='c12FilterClearAct' onClick={cleanFilter}>Limpiar filtros</span>
                    </div>
                }
                
                { 
                    PlayCategoriasData
                }
                {
                    PlayCategoriasDataHistory

                }
                
               
                <div className='c12FilterBlock c12FilterBlockBottom'>
                </div>

            </form>
        </div>
    )
})

ElementsFilter.propTypes = {
    onSubmit: PropTypes.func,
    showFilter: PropTypes.bool,
    setShowFilter: PropTypes.func,
    dataCCategorias: PropTypes.array,
    dataCCategoriasHistory: PropTypes.array,
    onChange: PropTypes.func,
    dataFilter: PropTypes.array,
    cleanFilter: PropTypes.func
}
ElementsFilter.defaultProps = {
    onSubmit: ()=>{},
    showFilter: true,
    setShowFilter: ()=>{},
    dataCCategorias: [],
    dataCCategoriasHistory: [],
    onChange: ()=>{},
    dataFilter: [],
    cleanFilter: ()=>{} 
}


function C12PersonasOrg() {

    const [dataCPromociones, setdataCPromociones] = useState([]);
    const [dataCPromocionesBkHead, setdataCPromocionesBkHead] = useState([]);
    const [dataCPromocionesBkHeadO, setdataCPromocionesBkHeadO] = useState([]);
    const [dataCPromocionesAllVigencia, setdataCPromocionesAllVigencia] = useState([]);
    const [optiondHigherLower, setOptiondHigherLower] = useState('')
    const [inputSearch, setinputSearch] = useState('')
    const [dataCCategorias, setdataCCategorias] = useState([]);
    const [dataCCategoriasHistory, setdataCCategoriasHistory] = useState([]);
    const [showFilter, setShowFilter] = useState(true);
    const [showPaginador, setShowPaginador] = useState(true);
    const [offset, setOffset] = useState(0);
   // const [pageCount, setPageCount] = useState(1);
    const [perPage, setPerPage] = useState(6);
    const [dataFilter, setDataFilter] = useState([]);
    const [dataFilterHistory, setDataFilterHistory] = useState([]);
    const [tituloSeccion, setTituloSeccion] = useState("");

    const {
        width: widthWindow,
    } = useWindowSize()

    function isBeforeToDay(date){
        const today = new Date()
        // today.setHours(0, 0, 0, 0)
        if(date !== undefined){
            date = new Date(date)
            // date.setHours(0, 0, 0, 0)
        }else{
            return false
        }
        return date < today
    }

    async function getCPromociones() {
        console.log("dataCPromociones*******************************+")
        let url_servicio_web = localStorage.getItem('url_servicio_web');
        let id_familia = localStorage.getItem('id_familia');
        let id_vigencia = localStorage.getItem('id_vigencia');
        const data = {
            "fi_familia": id_familia,
            "fi_vigencia": id_vigencia
        } ;

        const configCPlanes = {
            method: 'POST',
            url: url_servicio_web + "get_promociones_cards",
            data: data,
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json"
            },
        };
        
        let response = await axios(configCPlanes)
        
        let promoInit = response.data
        let newArrayPromo = promoInit.length > 0 ? promoInit.filter( p => ( p?.fd_FECHA_VIGENCIA_FIN === undefined || isBeforeToDay(p?.fd_FECHA_VIGENCIA_FIN) === false )) : [];
        //let pageCountVal = response.data ? (Math.ceil(response.data.length / perPage)) : 1;
        console.log("response- getCPromociones------------------------->", response, "promoInit:", newArrayPromo);
        setdataCPromociones(newArrayPromo);
        await setdataCPromocionesBkHead(newArrayPromo)
        await setdataCPromocionesBkHeadO(newArrayPromo)
        await setdataCPromocionesAllVigencia(response.data)

        //setPageCount(pageCountVal)
        setPerPage(6)
    }

    async function getCCategorias() {
        console.log("dataCCategorias*******************************+")
        let url_servicio_web = localStorage.getItem('url_servicio_web');
        let id_familia = localStorage.getItem('id_familia');
        
        const configCCategorias = {
            method: 'GET',
            url: url_servicio_web + "get_categorias?fi_familia=" + id_familia,
            data: {},
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json"
            },
        };
        
        let response = await axios(configCCategorias)
        console.log("response- getCCategorias------------------------->", response);
        let data = response?.data ? response.data : []
        if (data.length){
            let newArray = data.map((item, index)=>{
                item.active = false;
                return item
            })
            data = newArray
        }
        
        setdataCCategorias(data);
        
       
    }
    async function getCCategoriasHistorico() {
        console.log("getCCategoriasHistorico*******************************+")
        let url_servicio_web = localStorage.getItem('url_servicio_web');
        let id_familia = localStorage.getItem('id_familia');
        
        const configCCategorias = {
            method: 'GET',
            url: url_servicio_web + "get_categorias?fi_familia=" + id_familia,
            data: {},
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json"
            },
        };
        
        let response = await axios(configCCategorias)
        console.log("response- getCCategorias------------------------->", response);
        
        let dataHistory = response?.data ? response.data : []
        if (dataHistory.length){
            let newArrayHistory = dataHistory.map((item, index)=>{
                item.active = false;
                return item
            })
            dataHistory = newArrayHistory
        }
        setdataCCategoriasHistory(dataHistory);
    }

    async function getTituloSeccion() {
        let titulo = localStorage.getItem('titulo_seccion');
        setTituloSeccion(titulo);
    }
    
    // const handleChangePrice = useCallback( (valores) => {
    //     setValue('minPrice', valores.minPrice)
    //     setValue('maxPrice', valores.maxPrice)
    // }, [setValue] )
    const onSubmitFilter = data => {
        console.log('Submit filters:', data);
    }

    const getFilterPromocionesMulti = (filters = null, OrdHigherLower = null, input = null, filtersHistory = null) => {
       
       //Apartado filtros
       let promocionesFilter = filters && filters.length > 0 ? dataCPromocionesBkHead.filter( d => d.fi_FILTRO?.some(f => filters.includes(f))) : dataCPromocionesBkHead;
       if(filtersHistory?.length){
        let finalArray = []
        let promocionesFilterHistory = filtersHistory && filtersHistory.length > 0 ? dataCPromocionesAllVigencia.filter( d => (d.fi_FILTRO?.some(f => filtersHistory.includes(f)) && isBeforeToDay(d?.fd_FECHA_VIGENCIA_FIN) === true)) : [];
        if (filters.length > 0){
            finalArray = promocionesFilter.concat(promocionesFilterHistory)
            console.log("promocionesFilterHistory: finalArray ", finalArray)
        }else{
            finalArray = promocionesFilterHistory;
        }
        promocionesFilter = finalArray;
       }
       console.log("promocionesFilter",promocionesFilter)
       console.log("filters",filters)
       console.log("dataCPromociones",dataCPromociones)
       //Apartado buscar
       if(input && promocionesFilter){
        
        promocionesFilter = promocionesFilter.filter(f => 
            f.fc_TITULO?.toLowerCase().includes(input.toLowerCase()) ||
            f.fc_TEXTO_BULLET?.toLowerCase().includes(input.toLowerCase())
            )
       }
        //Apartado  ordenar
        let list = promocionesFilter
        let list2 = promocionesFilter
        list.sort();
        if (OrdHigherLower !== null) {
            console.log("OrdHigherLower !null ", OrdHigherLower)
            if (OrdHigherLower === "1") {
                list2.sort(function(a, b){
                    if(a.fc_TITULO < b.fc_TITULO) { return -1; }
                    if(a.fc_TITULO > b.fc_TITULO) { return 1; }
                    return 0;
                })
                console.log("OrdHigherLower >", OrdHigherLower)
            }
            if (OrdHigherLower === "2") {
                list2.sort(function(a, b){
                    if(a.fc_TITULO < b.fc_TITULO) { return 1; }
                    if(a.fc_TITULO > b.fc_TITULO) { return -1; }
                    return 0;
                })
                console.log("OrdHigherLower <", OrdHigherLower)
            }
            console.log("to OrdHigherLower----------:", list2)
            list = list2
        }
        
        setdataCPromociones(list);
        setOffset(0);

    }

    function getTitleCount2(){
        let numElement = dataCPromociones.slice(calculateInitElementShow(), calculateFnElementShow()).length
        let titleC= `${showPaginador ? numElement : dataCPromociones.length} Promociones de ${dataCPromociones.length}`;
        return titleC
    }   const onChangeFilter = (el, item) => {
        console.log("ingresio")
        let isCheck = el.target.checked;
        let idFiltro = parseInt(el.target.value);
        let filters = [...dataFilter]; // Copia de los filtros actuales
        
        if (isCheck) {
            filters.push(idFiltro);
        } else {
            filters = filters.filter(f => f !== idFiltro);
        }
        
        // Desactiva los filtros de "Histórico" si se selecciona un filtro principal
        let filtersHistory = isCheck ? [] : dataFilterHistory;
        
        setDataFilter(filters);
        setDataFilterHistory(filtersHistory);
        
        getFilterPromocionesMulti(filters, optiondHigherLower, inputSearch, filtersHistory);
    }
    
    
      const onChangeFilterHistory = (el, item) => {
        console.log("ingreso")
        let isCheck = el.target.checked;
        let idFiltro = parseInt(el.target.value);
        let filtersHistory = [...dataFilterHistory]; // Copia de los filtros de "Histórico" actuales
        
        if (isCheck) {
            filtersHistory.push(idFiltro);
        } else {
            filtersHistory = filtersHistory.filter(f => f !== idFiltro);
        }
        
        // Desactiva los filtros principales si se selecciona un filtro de "Histórico"
        let filters = isCheck ? [] : dataFilter;
        
        setDataFilter(filters);
        setDataFilterHistory(filtersHistory);   
        getFilterPromocionesMulti(filters, optiondHigherLower, inputSearch, filtersHistory);
    }
    
    const onChangeFilterActive = (active, filParent) => {
        console.log("onChangeFilterActive:", active, filParent)
        const newArrayData = dataCCategorias.map((item, index)=>{
            if ( item.fi_TIPO_FILTRO === filParent){
                item.active = !active
            }
            return item
        })
        setdataCCategorias(newArrayData)
    }
    const onChangeFilterActiveHistory = (active, filParent) => {
        console.log("onChangeFilterActiveHistory:", active, filParent)
        
        const newArrayDatahistory = dataCCategoriasHistory.map((item, index)=>{
            if ( item.fi_TIPO_FILTRO === filParent){
                item.active = !active
            }else{
                item.active = false
            }
            return item
        })
        setdataCCategoriasHistory(newArrayDatahistory)
    }

    const cleanFilter = () => {
        setDataFilter([])
        setDataFilterHistory([])
        setOptiondHigherLower('')
        setinputSearch('')
        setdataCPromociones(dataCPromocionesBkHeadO)
        //let pageCountVal = dataCPromocionesBkHead.length ? (Math.ceil(dataCPromocionesBkHead.length / perPage)) : 1;
        setOffset(0)
        //setPageCount(pageCountVal)
    }

    function calculateInitElementShow() {
        const result = showPaginador ? offset * perPage : 0
        return result
    }

    function calculateFnElementShow() {
        return showPaginador ? calculateInitElementShow() + perPage : dataCPromocionesBkHead.length
    }
    let version_comparador = localStorage.getItem('version_comparador')
    function btnLinkDetail(promo) {
        let linkText = "";
        if (promo?.fc_TIPO_URL_DETALLE === "URL"){
            linkText = `${promo.fc_URL_DETALLE}`;
        } else if (promo?.fc_TIPO_URL_DETALLE === "DEF"){
            let url_detalle_default = localStorage.getItem('url_detalle_default');
            if (version_comparador === "version_id"){
                linkText = `${url_detalle_default}${promo.fc_FRIENDLY_URL}-${promo.fi_ID_PROMOCION}/`;    
            }else{
                linkText = `${url_detalle_default}${promo.fc_FRIENDLY_URL}/`;
            }
        }
        return linkText;
    }

    function getCalculatePageCount() {
        
        let pageCountVal = dataCPromociones?.length ? (Math.ceil(dataCPromociones.length / perPage)) : 1;
        return pageCountVal
    }

    function handlePageClick(d) {
        console.log("handlePageClick::::::::::::::::::::::::", d)
        
        setOffset(d.selected)
    }


    function onChangeOptions(e) {
        let OrdHigherLower = e.target.value
        setOptiondHigherLower(OrdHigherLower)
        getFilterPromocionesMulti(dataFilter, OrdHigherLower,inputSearch,dataFilterHistory)
        console.log("onChangeOptions:", e.target.value, e)
    }

    function onHandleClickSearch(e) {
        getFilterPromocionesMulti(dataFilter, optiondHigherLower, inputSearch,dataFilterHistory)
    }

    function onChangeInputSearch(e) {
        console.log("onChangeInputSearch", e.target.value)
        let textValue = e.target.value
        if (textValue.length) {
            setinputSearch(textValue)

        } else {
            let list = dataCPromocionesBkHead
            list.sort((a, b) => (a.fc_TITULO > b.fc_TITULO) ? 1 : -1)
            setdataCPromociones(list)
            //let pageCountVal = list.length ? (Math.ceil(list.length / perPage)) : 1;
            setOffset(0)
            //setPageCount(pageCountVal)
        }
    }

    const PlayPromocionesData = dataCPromociones ? dataCPromociones.slice(calculateInitElementShow(), calculateFnElementShow()).map((item, index) => (
        <div key={uuid()} className="c12Item" data-idPromo={item.fi_ID_PROMOCION}>
        <PromoCardsMol
            key={uuid()}
            img={{
                ext: `${item.ext_IMAGEN_MIN}`,
                url: `${item.fc_IMAGEN_MINIATURA}`,
            }}
            promoColor = ""
            promo= ""
            altImagen = {item.fc_ALT_IMAGEN_MINIATURA}
            titleImagen = {item.fc_TITLE_IMAGEN_MINIATURA}
            title = {item.fc_TITULO}
            desc= {item.fc_DESCRIPCION}
            promoText = {item.fc_TEXTO_BULLET}
            btnTitle = {item.fc_TEXTO_DETALLE}
            btnLink = {btnLinkDetail(item)}
            target_L = {item?.fc_TIPO_URL_DETALLE === "URL" ? item.fc_TARGET_DETALLE : "" }
        />
    </div>
        ))
            : null;

    useEffect(() => {
        if(widthWindow > 960){
            setShowPaginador(true)
        }else if(widthWindow <= 960){
            setShowPaginador(false)
        }
        // eslint-disable-next-line
    }, [widthWindow, setShowPaginador]);

    useEffect(()=>{
        getCPromociones();
        getCCategorias();
        getCCategoriasHistorico();
        getTituloSeccion();
        // eslint-disable-next-line
    },[])

    useEffect(()=>{
        let filterType = parseInt(queryParams.get("filterType"))
        // let auxdata = dataCPromocionesBkHead
        // console.log("prefilter filterType", auxdata.length, filterType, auxdata)
        if(filterType !== null && dataCCategorias.length && dataCPromocionesBkHead.length){
            // console.log("prefilter filterType if", filterType)
            let el = { target: { checked: true, name: 'serMovil', value: filterType }}
            let item = dataCCategorias[0]?.filtros.filter(filt => filt.fi_FILTRO === filterType);
            if(item.length){
                console.log("prefilter filterType item", filterType, item)
                onChangeFilter(el, item[0]);
            }
        }
        // eslint-disable-next-line
    },[dataCCategorias, dataCPromocionesBkHead])
    console.log("reload1!!!!", dataCCategorias)
    console.log("reload2!!!!", dataCCategoriasHistory)
    return (
        <section className='c12Wrap'>
            <div className="container">
                <div className="c12">
                    <div className="c12Fil">
                        <ElementsFilter 
                            onSubmit={onSubmitFilter}
                            // rangePrice={rangePrice}
                            showFilter={showFilter}
                            setShowFilter={setShowFilter}
                            dataCCategorias={dataCCategorias}
                            dataCCategoriasHistory={dataCCategoriasHistory}
                            onChange={onChangeFilter}
                            onChangeHistory={onChangeFilterHistory}
                            dataFilter={dataFilter}
                            dataFilterHistory={dataFilterHistory}
                            cleanFilter={cleanFilter}
                            onChangeActive={onChangeFilterActive}
                            onChangeActiveHistory={onChangeFilterActiveHistory}
                            //setDataFilter={}
                        />
                    </div>
                    <div className="c12Cont">
                        <div className='c12Title'>
                     
                            
                            <p className='c12HeaderRight'>
                                {
                                    getTitleCount2()
                                }
                            </p>
                        </div>

                        <div className="c12Bar">
                            <div className="c12BarDrop">
                                {/* <Dropdown /> */}
                                <span className="select">
                                        <select value={optiondHigherLower} onChange={(e) => { onChangeOptions(e) }}>
                                            <option value='' disabled>Ordenar por:</option>
                                            <option value='1'>Nombre: A - Z</option>
                                            <option value='2'>Nombre: Z - A</option>
                                        </select>
                                </span>

                            </div>
                            <div className="c12BarSearch">
                                <SearchField onChange={e => onChangeInputSearch(e)}  value={inputSearch}/>

                            </div>
                            <div className="c12BarAct">
                                <Button onClick={e => onHandleClickSearch(e)}>
                                    Buscar
                                </Button>
                            </div>
                        </div>

                        <div className="c12Header">

                        <div className='c12HeaderFilter' onClick={()=>{setShowFilter(!showFilter)}}>
                                
                                <p>Filtros <i className='ico-sliders'></i></p>

                            </div>
                        </div>

                        <div className="c12Items">
                            {
                                PlayPromocionesData
                            }
                            
                        </div>
                        <div className="c12Pag">
                            {
                                dataCPromociones.length && dataCPromociones.length > perPage 
                                    ?   
                                        <PaginationMol 
                                            pageCount={getCalculatePageCount()}
                                            onPageChange={handlePageClick}
                                            initialPage={0}
                                            forcePage={offset}
                                        />
                                    : null
                            }
                            
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default C12PersonasOrg
